import * as yup from 'yup';

export const denyRectificationSchema = yup.object().shape({
  reason: yup.string().required(),
});
